import { multiStep } from 'components/Wizards/MultiStepWizard/multiStep'
import { TemplateAndCaption } from '../Steps/TemplateAndCaption/TemplateAndCaption'
import { StepProps } from 'components/Wizards/MultiStepWizard/Types'
import { useAutocomplete } from '../../useAutocomplete'
import { MultiStepSchema } from 'components/Wizards/schemas/Types'
import { useWizardSchema } from 'components/Wizards/Wizard/WizardContext'
import { useEffect, useState } from 'react'
import { PollFieldsetCompletion } from 'components/PollFieldsetCompletion/PollFieldsetCompletion'

interface Props {
  templateName: string
  templateFieldDescription?: string
}

export const TemplateStepWrapper = multiStep<StepProps & Props>(
  ({ templateName, templateFieldDescription, ...props }) => {
    const schema = useWizardSchema() as MultiStepSchema
    const [isFileNameLoading, setIsFileNameLoading] = useState(false)
    const [initialValues, setInitialValues] = useState<{ [key: string]: any }>(props.initialValues)
    const { handleComplete, handleGenerate, data } = useAutocomplete({
      schema,
      values: props.initialValues,
      setFieldValue: async (key, value) => setInitialValues((prev) => ({ ...prev, [key]: value })),
      onLoadingChange: setIsFileNameLoading,
    })

    // FlowB doesn't have a dedicated step for the topic field, it needs to be generated once the image is selected
    useEffect(() => {
      if (initialValues.initial_media_file_id) {
        handleGenerate({ fields: ['topic'] })
      } else {
        setInitialValues((prev) => ({ ...prev, topic: templateName }))
      }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <>
        <PollFieldsetCompletion fieldsetCompletionId={data?.fieldset_completion.id} onComplete={handleComplete} />
        <TemplateAndCaption
          {...props}
          initialValues={initialValues}
          templateFieldDescription={templateFieldDescription}
          showBrandKitInput={initialValues.startWithTemplate}
          isFileNameLoading={isFileNameLoading}
          onBrandKitChange={(brandKitId) =>
            handleGenerate({ fields: ['filename'], newCompletedFields: { brand_kit_id: brandKitId } })
          }
        />
      </>
    )
  },
)
